import React, {Component} from "react";
import './SalesTableRow.css';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import Select from "react-select";
import {Modal} from "react-bootstrap";
import axios from "axios";
import {BASE_URL, RESOURCE_BASE_URL} from "../../../../../configuration";
import NumberFormatter from "../../../../Common/NumberFormatter/NumberFormatter";
import OrderItemProductionStatus
    from "../../../Order/ViewAllOrders/OrderTableRow/OrderItemProductionStatus/OrderItemProductionStatus";
import NumericLabel from 'react-pretty-numbers';


class SalesTableRow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            status: 'Pending review',
            showTrack: false,
            statusData: [],
            statusCode: '',
            productionResult: [],
            sagawaCodes:[]

        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.truncate = this.truncate.bind(this);
        this.getOrderStatus = this.getOrderStatus.bind(this);
        this.getSagawaCodesForOrder = this.getSagawaCodesForOrder.bind(this);
    }

    onSubmit = event => {

        event.preventDefault();
        // this.saveStatus(); //TODO
        this.handleClose();
    };

    handleShow = () => {
        this.setState({
            show: true
        });
    };

    handleClose = () => {
        this.setState({show: false});
    };

    trackingOpen = () => {
        if(this.props.orders.shippedDate!==null) {
            this.getSagawaCodesForOrder()
        }
        this.setState({showTrack: true});
        this.getOrderProductionStatus();
    };

    impersonatePerson = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/user-new/impersonate/login/' + this.props.orders.batchNumber, axiosConfig)
            .then((res) => {
                localStorage.setItem("oldTokenString", localStorage.getItem("tokenString"));
                localStorage.removeItem("tokenString");
                localStorage.setItem("newTokenString", res.data.payload.tokenString);
                localStorage.setItem("userRole", res.data.payload.userRole);
                window.location.href = BASE_URL + 'order/all';
            })
    };

    trackingClose = () => {
        this.setState({
            showTrack: false
        });
    };

    changeStatus = (event) => {
        this.setState({
                status: event.value
            }
        )
    };

    truncate(s) {
        if (s.length > 15) {
            return s.substring(0, 12) + "...";
        } else {
            return s;
        }

    };

    getOrderStatus = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/jlcpcb/order/status/' + this.props.orders.batchNumber, axiosConfig)
            .then((res) => {
                this.setState({
                    statusData: res.data,
                    statusCode: res.data.orderStatus
                });
                // console.log(res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    getOrderProductionStatus = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        var orderUUID;
        this.props.orders.orderItems.map(value => orderUUID = value.orderUUID);
        axios.get(RESOURCE_BASE_URL + 'api/jlcpcb/order/production/status/' + orderUUID + '/' + this.props.orders.id, axiosConfig)
            .then((res) => {
                this.setState({
                    productionResult: res.data.result.wipProcesses
                });
                // console.log(res.data);
            })
            .catch((err) => {
                // console.log("[API] ERROR: ", err);

            });
    };

    getSagawaCodesForOrder = () => {
        axios.get(RESOURCE_BASE_URL + 'api/order/'+this.props.orders.id+'/track/sagawa')
            .then((res) => {
                this.setState({
                    sagawaCodes: res.data,

                });
                // console.log("sagawa codes",res.data)

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    componentDidMount() {
        // this.getOrderStatus();
    }

    render() {
        const options = [
            {value: 'Cancel', label: 'Cancel'},
            {value: 'Pending review', label: 'Pending review'},
            {value: 'Confirm', label: 'Confirm'},
            {value: 'Ordered', label: 'Ordered'},
            {value: 'In production', label: 'In production'},
            {value: 'Shipped', label: 'Shipped'}
        ];

        // console.log("ORDERSSSSSSSSSS ======> ", this.props.orders);
        let option = {
            'locales': 'en-AU',
            'precision': 2,
            'wholenumber': null,
            'commafy': true
        };
        let dollarAmount = this.props.orders.dollarAmount;

        return (
            <tr>
                <td>{this.props.orders.batchNumber}</td>
                <td>
                    {!this.props.hideOrderStatus ?
                        <span>
                        {this.props.orders.createdOn.substring(0, 4)}年 {this.props.orders.createdOn.substring(5, 7)}月&nbsp;
                            {this.props.orders.createdOn.substring(8, 10)}日
                    </span>
                        :
                        this.props.orders.shippedDate!==null &&
                        <span>
                            {this.props.orders.shippedDate.substring(0, 4)}年 {this.props.orders.shippedDate.substring(5, 7)}月&nbsp;
                            {this.props.orders.shippedDate.substring(8, 10)}日
                        </span>


                    }
                </td>
                <td>
                    <div>
                        <div>{this.props.orders.orderInfo.shippingAddress.lastName}&nbsp;{this.props.orders.orderInfo.shippingAddress.firstName} </div>
                        <div>{this.props.orders.orderInfo.shippingAddress.postalCode}</div>
                        <div>{this.props.orders.orderInfo.shippingAddress.province}&nbsp;{this.props.orders.orderInfo.shippingAddress.city}</div>
                        <div>{this.props.orders.orderInfo.shippingAddress.streetAddress}</div>
                        <div>{this.props.orders.orderInfo.shippingAddress.addressLine2}</div>
                        {/*<div>{this.props.orders.orderInfo.shippingAddress.country}</div>*/}
                        <div>{this.props.orders.orderInfo.shippingAddress.billContact}</div>
                    </div>
                </td>
                <td>
                    <span>
                        {this.props.orders.dollarAmount !== null ?
                            <NumericLabel params={option}>{dollarAmount}</NumericLabel> : 0.0}

                        {/*{this.props.orders.orderTotal !== null ? <NumberFormatter num = {this.props.orders.orderTotal}/> : 0}*/}
                        {/*{(this.props.orders.orderTotal/107).substring((this.props.orders.orderTotal/107).lastIndexOf("."))}*/}
                    </span>
                </td>
                <td>
                    <span>
                        {this.props.orders.orderTotal !== null ?
                            <NumberFormatter num={this.props.orders.orderTotal}/> : 0}

                    </span>
                </td>
                <td>
                     <span>

                         <small>
                            {this.props.orders.status === "IN_PRODUCTION" ? '生産中' : ''}
                             {this.props.orders.status === "PENDING" ? '保留中' : ''}
                             {this.props.orders.status === "IN_WAREHOUSE" ? '倉庫内' : ''}
                             {this.props.orders.status === "SHIPPED" ? '発送済み' : ''}
                             {this.props.orders.status === "DELIVERED" ? '配信済み' : ''}
                        </small>

                    </span>
                </td>
                <td>
                    <Link to={"view/" + this.props.orders.id} className="btn btn-xs btn-warning">
                        <FormattedMessage id="app.admin-all-row.view"
                                          defaultMessage="View"
                                          description=""/>
                    </Link>
                    &nbsp;
                    <button className="btn btn-xs btn-success" onClick={this.trackingOpen}>
                        <FormattedMessage id="app.admin-all-row.track"
                                          defaultMessage="Track"
                                          description=""/>
                    </button>
                    &nbsp;
                    <div hidden={true}>
                        <button className="btn btn-xs btn-primary" onClick={this.handleShow}>
                            <FormattedMessage id="app.admin-all-row.status"
                                              defaultMessage="Status"
                                              description=""/>
                        </button>
                    </div>

                    &nbsp;
                    <div>
                        <button className="btn btn-xs btn-primary" onClick={this.impersonatePerson}>
                            <FormattedMessage id="app.admin-all-row.impersonate"
                                              defaultMessage="Status"
                                              description=""/>
                        </button>
                    </div>


                    <Modal show={this.state.show} onHide={this.handleClose}>
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                <FormattedMessage id="app.admin.order.status"
                                                  defaultMessage="CHANGE STATUS:"
                                                  description=""/>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row color-text">
                                <div className="col-md-3">
                                    <label>
                                        <FormattedMessage id="app.admin.order.change-status"
                                                          defaultMessage="Change status to:"
                                                          description=""/>
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    <Select name="status"
                                            isLoading={true}
                                            isSearchable={true}
                                            defaultValue={this.state.status}
                                            options={options}
                                            onChange={this.changeStatus}
                                    />
                                </div>
                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                            <div className="row color-text">
                                <div className="col-md-2 pull-right">
                                    <button className="btn btn-primary bottom-button" onClick={this.onSubmit}>
                                        <FormattedMessage id="app.admin.change.status.save"
                                                          defaultMessage="Save"
                                                          description=""/>
                                    </button>
                                </div>
                                <div className="col-md-2">
                                    <button className="btn btn-default bottom-button" onClick={this.handleClose}>
                                        <FormattedMessage id="app.admin.change.status.close"
                                                          defaultMessage="Close"
                                                          description=""/>
                                    </button>
                                </div>
                            </div>
                        </Modal.Footer>
                    </Modal>

                    <Modal dialogClassName="production-status-dialog" show={this.state.showTrack}
                           onHide={this.trackingClose} className="track-order-modal">
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                {/*<FormattedMessage id="app.site.track.production.title"
                                              defaultMessage="TRACK PRODUCTION PROCESS"
                                              description=""/>*/}
                                {/*<span>{this.props.order.id}</span>*/}
                                輸送状況の確認
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row color-text">
                                        <div className="col-md-4 resp-tracking-headings">
                                            <label>
                                                <FormattedMessage id="app.site.track.production.order-id"
                                                                  defaultMessage="Order ID: "
                                                                  description=""/></label>
                                        </div>
                                        <div className="col-md-8 pull-left resp-tracking-content">
                                            <span>{this.props.orders.id}</span>
                                        </div>
                                    </div>
                                    <div className="row color-text">
                                        <div className="col-md-4 resp-tracking-headings">
                                            <label>
                                                注文日
                                            </label>
                                        </div>
                                        <div className="col-md-8 pull-left resp-tracking-content">
                                    <span>
                                        {this.props.orders.createdOn.substring(0,4)}年 {this.props.orders.createdOn.substring(5,7)}月 {this.props.orders.createdOn.substring(8,10)}日
                                    </span>
                                        </div>
                                    </div>

                                    <div className="row color-text">
                                        <div className="col-md-4 resp-tracking-headings">
                                            <label>
                                                {/*<FormattedMessage id="app.site.track.production.batch-no"*/}
                                                {/*defaultMessage="Batch No"*/}
                                                {/*description=""/>:*/}
                                                注文番号:

                                            </label>
                                        </div>
                                        <div className="col-md-8 pull-left resp-tracking-content">
                                            <span>{this.props.orders.batchNumber}</span>
                                        </div>
                                    </div>
                                    <div className="row color-text">
                                        <div className="col-md-4 resp-tracking-headings">
                                            <label>
                                                <FormattedMessage id="app.site.track.production.order-status"
                                                                  defaultMessage="Order Status: "
                                                                  description=""/></label>
                                        </div>
                                        <div className="col-md-8 pull-left resp-tracking-content">
                                <span>
                                    {/*{this.state.status}*/}
                                    {this.props.orders.status === "IN_PRODUCTION" ? '生産中' : ''}
                                    {this.props.orders.status === "PENDING" ? '保留中' : ''}
                                    {this.props.orders.status === "IN_WAREHOUSE" ? '倉庫内' : ''}
                                    {this.props.orders.status === "SHIPPED" ? '発送済み' : ''}
                                    {this.props.orders.status === "DELIVERED" ? '配信済み' : ''}

                                    {/*{this.state.statusCode}*/}

                                </span>
                                        </div>
                                    </div>
                                    <div className="row color-text">
                                        <div className="col-md-4 resp-tracking-headings">
                                            <label>
                                                出荷日
                                            </label>
                                        </div>
                                        <div className="col-md-8 pull-left resp-tracking-content">
                                    <span>
                                        {this.props.orders.shippedDate!==null ?
                                            <text>
                                                {this.props.orders.shippedDate.substring(0,4)}年 {this.props.orders.shippedDate.substring(5,7)}月 {this.props.orders.shippedDate.substring(8,10)}日

                                            </text>:
                                            <text>まだ利用できません</text>
                                        }

                                    </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row color-text">
                                        <div className="col-md-4 resp-tracking-headings">
                                            <label>
                                                お届け先住所

                                            </label>
                                        </div>
                                        <div className="col-md-8 pull-left resp-tracking-content">
                                        <span>
                                             <div>{this.props.orders.orderInfo.shippingAddress.lastName}&nbsp;{this.props.orders.orderInfo.shippingAddress.firstName} </div>
                                                <div>{this.props.orders.orderInfo.shippingAddress.postalCode}</div>
                                                <div>{this.props.orders.orderInfo.shippingAddress.province}</div>
                                                <div>{this.props.orders.orderInfo.shippingAddress.city}</div>
                                                <div>{this.props.orders.orderInfo.shippingAddress.streetAddress}</div>
                                                <div>{this.props.orders.orderInfo.shippingAddress.addressLine2}</div>
                                            {/*<div>{this.props.orders.orderInfo.shippingAddress.country}</div>*/}
                                            <div>{this.props.orders.orderInfo.shippingAddress.billContact}</div>
                                        </span>
                                        </div>
                                    </div>
                                    <div className="row color-text">
                                        <div className="col-md-4 resp-tracking-headings">
                                            <label>
                                                配送方法
                                            </label>
                                        </div>
                                        <div className="col-md-8 pull-left resp-tracking-content">
                                            <span>SGX（佐川国際宅配便）</span>
                                        </div>
                                    </div>
                                    <div className="row color-text">
                                        <div className="col-md-4 resp-tracking-headings">
                                            <label>
                                                問合せ番号

                                            </label>
                                        </div>
                                        <div className="col-md-8 pull-left resp-tracking-content">
                                        <span>  {this.props.orders.shippedDate!==null ?

                                            this.state.sagawaCodes.length > 0 &&
                                            <text>{this.state.sagawaCodes[0].substring(1,13)}</text> :
                                            <text>まだ利用できません</text>
                                        }</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <hr className="quotation-summary-hr"/>
                                </div>
                            </div>
                            <div className="row color-text">

                                <div className="modal-table-responsive">

                                    <div className="col-md-12 no-padding modal-table-fixed-width">
                                        <div className="col-md-2 custom-col-2"><label>
                                            <FormattedMessage id="app.site.track.production.item-id"
                                                              defaultMessage="Item ID"
                                                              description=""/>
                                        </label></div>
                                        <div className="col-md-3 custom-col-3"><label>
                                            <FormattedMessage id="app.site.track.production.item-image"
                                                              defaultMessage="Image"
                                                              description=""/>
                                        </label></div>
                                        <div className="col-md-7 custom-col-7">
                                            <div className="col-md-6 custom-col-6 no-padding">
                                                <label>
                                                    <FormattedMessage id="app.site.track.production.begin-time"
                                                                      defaultMessage="Begin Time"
                                                                      description=""/>
                                                </label>
                                            </div>
                                            <div className="col-md-4 custom-col-4" id="process-heading-name2">
                                                <label>
                                                    <FormattedMessage id="app.site.track.production.process-name"
                                                                      defaultMessage="Process Name"
                                                                      description=""/></label>
                                            </div>
                                        </div>
                                    </div>
                                    {/*<OrderItemProductionStatus orderItems = {this.props.orders.orderItems}/>*/}
                                    <div className="modal-table-fixed-width">
                                        {
                                            this.props.orders.orderItems.map((item) => {
                                                return <OrderItemProductionStatus key={item.barcode} orderItem={item}
                                                                                  orderId={this.props.orders.id}/>
                                            })
                                        }
                                    </div>

                                </div>

                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                            <div className="col-md-offset-2 pull-right color-text">
                                <button className="btn btn-info bottom-button" onClick={this.trackingClose}>
                                    <FormattedMessage id="app.site.track.production.close"
                                                      defaultMessage="Close"
                                                      description=""/>
                                </button>
                            </div>
                        </Modal.Footer>
                    </Modal>

                </td>
            </tr>

        )
    }
}

export default SalesTableRow;



// WEBPACK FOOTER //
// ./src/components/Admin/Sales/ViewAllSales/SalesTableRow/SalesTableRow.js